<template>
    <div class="map" v-if="ethnosData">

        <svg id="Ebene_2" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 305">
            <text class="cls-1" :class="{'active': ethnoInfo('saami').active}" transform="translate(45.085 136.6823)"
                @click="goToEthnicGroup('saami')">
                {{ ethnoInfo('saami').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('nenzen').active}" transform="translate(175.7915 128.7825)"
                @click="goToEthnicGroup('nenzen')">
                {{ ethnoInfo('nenzen').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('komi').active}" transform="translate(154.3439 151.1089)"
                @click="goToEthnicGroup('komi')">
                {{ ethnoInfo('komi').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('mansen').active}" transform="translate(197.6201 164.2997)"
                @click="goToEthnicGroup('mansen')">
                {{ ethnoInfo('mansen').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('forest-nenets-and-khanty').active}" transform="translate(224.211 182.7193)"
                @click="goToEthnicGroup('forest-nenets-and-khanty')">
                {{ ethnoInfo('forest-nenets-and-khanty').title }}</text>
            <text class="cls-7" :class="{'active': ethnoInfo('enzen').active}" transform="translate(286.9218 80.1281)"
                @click="goToEthnicGroup('enzen')">
                {{ ethnoInfo('enzen').title }}</text>
            <text class="cls-7" :class="{'active': ethnoInfo('nganasanen').active}" transform="translate(301.0419 56.1089)"
                @click="goToEthnicGroup('nganasanen')">
                {{ ethnoInfo('nganasanen').title }}</text>
            <text class="cls-7" :class="{'active': ethnoInfo('dolganen').active}" transform="translate(365.9074 89.5768)"
                @click="goToEthnicGroup('dolganen')">
                {{ ethnoInfo('dolganen').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('keten').active}" transform="translate(286.6154 195.5007)"
                @click="goToEthnicGroup('keten')">
                {{ ethnoInfo('keten').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('saami').active}" transform="translate(321.5354 248.4133)"
                @click="goToEthnicGroup('tyva')">
                {{ ethnoInfo('tyva').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('evenken').active}" transform="translate(350.1399 168.5077)"
                @click="goToEthnicGroup('evenken')">
                {{ ethnoInfo('evenken').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('jakuten-sacha').active}" transform="translate(380.0852 192.0805)"
                @click="goToEthnicGroup('jakuten-sacha')">
                {{ ethnoInfo('jakuten-sacha').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('nenzen').active}" transform="translate(243.6647 146.1069)"
                @click="goToEthnicGroup('nenzen')">
                {{ ethnoInfo('nenzen').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('evenen').active}" transform="translate(448.9729 151.0845)"
                @click="goToEthnicGroup('evenen')">
                {{ ethnoInfo('evenen').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('jukagiren').active}" transform="translate(527.6246 136.8547)"
                @click="goToEthnicGroup('jukagiren')">
                {{ ethnoInfo('jukagiren').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('cukcen').active}" transform="translate(595.5974 129.449)"
                @click="goToEthnicGroup('cukcen')">
                {{ ethnoInfo('cukcen').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('korjaken').active}" transform="translate(560.4081 187.9126)"
                @click="goToEthnicGroup('korjaken')">
                {{ ethnoInfo('korjaken').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('itelmenen').active}" transform="translate(537.1442 220.2604)"
                @click="goToEthnicGroup('itelmenen')">
                {{ ethnoInfo('itelmenen').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('negidalen').active}" transform="translate(421.8044 248.0134)"
                @click="goToEthnicGroup('negidalen')">
                {{ ethnoInfo('negidalen').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('nanaj').active}" transform="translate(440.278 265.6305)"
                @click="goToEthnicGroup('nanaj')">
                {{ ethnoInfo('nanaj').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('udegen').active}" transform="translate(433.7495 282.9155)"
                @click="goToEthnicGroup('udegen')">
                {{ ethnoInfo('udegen').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('nivchen').active}" transform="translate(485.6261 241.4718)"
                @click="goToEthnicGroup('nivchen')">
                {{ ethnoInfo('nivchen').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('ulcen').active}" transform="translate(482.242 258.3123)"
                @click="goToEthnicGroup('ulcen')">
                {{ ethnoInfo('ulcen').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('orocen').active}" transform="translate(480.1393 286.0674)"
                @click="goToEthnicGroup('orocen')">
                {{ ethnoInfo('orocen').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('oroken').active}" transform="translate(487.3492 271.7111)"
                @click="goToEthnicGroup('oroken')">
                {{ ethnoInfo('oroken').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('evenen').active}" transform="translate(521.3301 168.7148)"
                @click="goToEthnicGroup('evenen')">
                {{ ethnoInfo('evenen').title }}</text>
            <text class="cls-1" :class="{'active': ethnoInfo('evenen').active}" transform="translate(561.4961 236.2684)"
                @click="goToEthnicGroup('evenen')">
                {{ ethnoInfo('evenen').title }}</text>
        </svg>       
    </div>
</template>

<script>

    export default {
        name: 'Ethnic-Communities-Map',
        props: {
            ethnosData: Array
        },
        computed: {
            ethnos () {
                return this.ethnosData.map(e => {
                    return {
                        title: e.titel,
                        slug: e.slug,
                        active: e.nurName
                            ? false
                            : true
                    }
                }) 
            }
        },
        methods: {
            ethnoInfo(slug) { 
                return this.ethnos.find(e => e.slug === slug)
            },
            goToEthnicGroup(group) {
                this.$router.push(`/ethnie/${group}`)
            }

        }
    }
</script>

<style lang="scss" scoped>
svg {
    width: 100%;
    background-image: url("/img/Sibirien_ohne_Namen.jpg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 4rem;
}
text {
    opacity: .70;
}
text.active {
    cursor: pointer;
    opacity: 1;
    &:hover {
        text-decoration: underline;
    }
}
.cls-1, .cls-7 {
        font-size: 12px;
        font-family: "MyriadPro-Regular", "Myriad Pro", sans-serif;
      }

      .cls-1 {
        fill: #f0cb26;
      }
      .cls-7 {
        fill: #f06326;
      }

</style>